import React from "react";
import { Stepper, Step, StepLabel, Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import StyledStepper from "./StyledStepper";
import { StyledSepperSteps } from "./StyledStepper";

const CustomStepIcon = (props) => {
  const { active, completed, icon } = props;

  return (
    <StyledSepperSteps>
      {completed ? (
        <Box className="completed">
          <CheckIcon color="white" className="check-icon" />
        </Box>
      ) : active ? (
        <Box className="active-step">{icon}</Box>
      ) : (
        <Box className="not-active-step">{icon}</Box>
      )}
    </StyledSepperSteps>
  );
};

const StepperComponent = ({ steps, activeStep }) => {
  return (
    <StyledStepper>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              <Typography className="label-text">{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </StyledStepper>
  );
};

export default StepperComponent;
